// extracted by mini-css-extract-plugin
export var actionButton = "_kg-t";
export var buttonContainer = "_kg-0";
export var buttonContainer2 = "_kg-1";
export var buttonSection = "_kg-2";
export var details = "_kg-3";
export var dropdownItem = "_kg-5";
export var dropdownItemsContainer = "_kg-4";
export var fileInput = "_kg-r";
export var headerButton = "_kg-6";
export var icon = "_kg-7";
export var input = "_kg-8";
export var macroListItem = "_kg-9";
export var mainContent = "_kg-a";
export var microText = "_kg-b";
export var modal = "_kg-w";
export var optionsButton = "_kg-c";
export var paperclip = "_kg-s";
export var pillContent = "_kg-d";
export var preview = "_kg-e";
export var preview2 = "_kg-f";
export var quillEditor = "_kg-q";
export var selectedMacro = "_kg-g";
export var sidebar = "_kg-h";
export var sidebarHeader = "_kg-j";
export var sidebarList = "_kg-i";
export var sidebarListItem = "_kg-k";
export var sidebarSearch = "_kg-l";
export var snoozeDurationWrapper = "_kg-v";
export var statusPillContainer = "_kg-m";
export var tagsContainer = "_kg-n";
export var unselectedMacro = "_kg-o";
export var variable = "_kg-u";
export var wrapper = "_kg-p";